// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1K1ZG","label":"CategoryService_label__3ePLS","location":"CategoryService_location__sL7cb"};